// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"ZO-z","inlineTitle":"_O-z","sponsoredAdsWrapper":"aP-z","marketplaceRecosWrapper":"bP-z"};